import { render, staticRenderFns } from "./editPrivacyPolicy.vue?vue&type=template&id=1f88199d&scoped=true&"
import script from "./editPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./editPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./editPrivacyPolicy.vue?vue&type=style&index=0&id=1f88199d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f88199d",
  null
  
)

export default component.exports